import styles from './SectionHeader.module.scss'
import { SectionHeaderProps } from './types.ts'
import viewportHelper from '@content/helpers/src/viewport.helpers'
import Image from '@commons/image/Image.tsx'
import React from 'preact/hooks'

const SectionHeader = ({
    align = 'left',
    alignMobile = 'center',
    contrast_mobile,
    contrast = 'light',
    logo = '',
    subhead = '',
    headline = '',
    description = '',
    small = false,
    className = '',
    ariaLabelledby = '',
    headlineTag: Tag = 'h3'
}: SectionHeaderProps) => {
    if (viewportHelper.is.mobile) {
        align = alignMobile ? alignMobile : align
        contrast = contrast_mobile ? contrast_mobile : contrast
    }

    const alignClass = styles['heading__align--' + align]
    const contrastClass = styles['heading__contrast--' + contrast]

    return (
        <div
            className={`${className} ${styles.heading} ${alignClass ? alignClass : ''} ${contrastClass}`}>
            {logo && <Image src={logo.desktop.src} alt={logo.desktop.alt} />}
            {subhead && <h4 className={styles.subhead}>{subhead}</h4>}
            {headline && (
                <Tag
                    className={
                        small ? styles['headline--small'] : styles.headline
                    }
                    aria-labelledby={ariaLabelledby}>
                    {headline}
                </Tag>
            )}
            {description && <p className={styles.description}>{description}</p>}
        </div>
    )
}

export default SectionHeader
